module.exports = __webpack_public_path__ + "img/panda-bandwidth-feedback-warning.7b0af965.svg";